// Texty bloku najnižšej ceny a grafu vývoja ceny — slovenské dvojče locale/cs/priceHistory.js.
import { withCurrency } from '../../modules/money.js';

export default {
  labels: {
    omnibus: 'Najnižšia cena za 30 dní pred zľavou',
    low30: 'Najnižšia cena za posledných 30 dní',
    atMin: '· aktuálne najnižšia cena',
    toggle: 'Vývoj ceny',
    title: 'Vývoj ceny',
    from: 'od',
    today: 'dnes',
    caption: 'Predajná cena s DPH',
    captionBand: 'ružové pásmo = prebiehajúca akcia',
    refOmnibus: 'Najnižšia cena 30 dní pred zľavou',
    refOmnibusShort: '30 dní pred zľavou',
    refLow30: 'Najnižšia cena za posledných 30 dní',
    refLow30Short: 'posledných 30 dní',
  },
  aria: (from, min, max, now, sym) =>
    'Vývoj predajnej ceny od ' + from + ', rozpätie ' + withCurrency(min) + ' až ' + withCurrency(max) + ', aktuálne ' + withCurrency(now),
};
